import { render, staticRenderFns } from "./EnterNewPartCarRegPage.vue?vue&type=template&id=50cc83b6&scoped=true&"
import script from "./EnterNewPartCarRegPage.vue?vue&type=script&lang=js&"
export * from "./EnterNewPartCarRegPage.vue?vue&type=script&lang=js&"
import style0 from "./EnterNewPartCarRegPage.vue?vue&type=style&index=0&id=50cc83b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cc83b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VIcon,VRow})
